export const registerRoute = () => '/register'
